export default {
  zh: {
    accept:"Accept",
    reject:"Reject",
    underreview:"waiting App' admin review",
    id:"ID",
    rejected:"Rejected",
    agreed:"Agreed",
    joinapplication:"Host Review",
    have:'The user had joined another Agency',
    emptyText:"Oops, no Apply record yet.",
    sesmsg:"The operation was successful",
  },
  en: {
    accept:"Accept",
    reject:"Reject",
    underreview:"waiting App' admin review",
    id:"ID",
    rejected:"Rejected",
    agreed:"Agreed",
    joinapplication:"Host Review",
    have:'The user had joined another Agency',
    emptyText:"Oops, no Apply record yet.",
    sesmsg:"The operation was successful",
  },
  ar: { // 阿拉伯
    accept:"تقبل",
    reject:" رفض",
    underreview:"بإنتظار مراجعة مشرف تشاتي",
    id:"ID",
    rejected:" مرفوض",
    agreed:" تمت الموافقة",
    joinapplication:"طلبات التقديم",
    have:'انضم المستخدم إلى وكالة أخرى',
    emptyText:"عفوا ، لا يوجد سجل تطبيق حتى الآن.",

    sesmsg:"العملية كانت ناجحه",
  },
  tr:{ //土耳其
    accept:"Almak",
    reject:"Reddet",
    underreview:"App' yönetici incelemesi bekleniyor ",
    id:"ID",
    rejected:"Reddedilmiş",
    agreed:"Kabul Edildi",
    joinapplication:"Uygulamaya Katıl",
    have:'Kullanıcı başka bir Ajansa katılmıştı',
    emptyText:"Üzgünüz, henüz Kayıt uygula yok.",
    sesmsg:"İşlem Başarılı Oldu",
  },
  pt: {
        "accept": "Aceitar",
        "reject": "Rejeitar",
        "underreview": "Aguardando revisão do administrador do App",
        "id": "ID",
        "rejected": "Rejeitado",
        "agreed": "Aprovado",
        "joinapplication": "Revisão do anfitrião",
        "have": "O usuário entrou em outra agência",
        "emptyText": "Ops, nenhum registro de inscrição ainda.",
        "sesmsg": "A operação foi bem-sucedida"
    },
    id: {
        "accept": "Terima",
        "reject": "Tolak",
        "underreview": "Menunggu tinjauan admin App",
        "id": "ID",
        "rejected": "Ditolak",
        "agreed": "Disetujui",
        "joinapplication": "Tinjauan Pengundang",
        "have": "Pengguna telah bergabung dengan agensi lain",
        "emptyText": "Ups, belum ada catatan aplikasi.",
        "sesmsg": "Operasi berhasil"
    },
    uz: {
        "accept": "Qabul qilish",
        "reject": "Rad etish",
        "underreview": "App adminining ko'rib chiqishini kutish",
        "id": "ID",
        "rejected": "Rad etilgan",
        "agreed": "Rozilik bildirilgan",
        "joinapplication": "Xostni ko'rib chiqish",
        "have": "Foydalanuvchi boshqa agentlikka qo'shildi",
        "emptyText": "Afsuski, hali hech qanday ariza mavjud emas.",
        "sesmsg": "Amaliyot muvaffaqiyatli bajarildi"
    },
    ru: {
        "accept": "Принять",
        "reject": "Отклонить",
        "underreview": "Ожидает проверки администратора App",
        "id": "ID",
        "rejected": "Отклонено",
        "agreed": "Согласовано",
        "joinapplication": "Проверка хоста",
        "have": "Пользователь присоединился к другой агентству",
        "emptyText": "Упс, пока нет записей заявок.",
        "sesmsg": "Операция прошла успешно"
    },
    fa: {
        "accept": "پذیرفتن",
        "reject": "رد کردن",
        "underreview": "منتظر بررسی مدیر اپلیکیشن",
        "id": "ID",
        "rejected": "رد شده",
        "agreed": "موافقت شد",
        "joinapplication": "بررسی میزبان",
        "have": "کاربر به یک آژانس دیگر پیوسته است",
        "emptyText": "اوپس، هنوز هیچ رکوردی برای درخواست وجود ندارد.",
        "sesmsg": "عملیات با موفقیت انجام شد"
    }
}


// WEBPACK FOOTER //
// src/pages/app/join-application/lang.js